
export function AccountDropdown() {
  // Auth removed - AccountDropdown no longer needed since auth is disabled
  return null;
}
